module.exports = __webpack_public_path__ + "img/icon-competence-4.6854106b.svg";